import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=4e4b93f6&scoped=true&"
import script from "./delivery.vue?vue&type=script&lang=ts&"
export * from "./delivery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4b93f6",
  null
  
)

export default component.exports